import React from 'react';
import VehicleHub from './VehicleHub';

const config = {
  // Blog guides about this model, rendered as the hub's spoke links. Posts
  // whose own target is this hub's query ("buy/used <model> taxi Delhi")
  // are deliberately left out — linking them would build a competitor.
  guides: [
    'dzire-cng-mileage-real-world-taxi',
    'used-swift-dzire-taxi-review',
    'sell-dzire-taxi-best-price-india',
    'cng-vs-diesel-taxi-india',
  ],
  slug: '/dzire-commercial-taxi-delhi',
  brand: 'Maruti Suzuki',
  model: 'Dzire',
  displayName: 'Maruti Suzuki Dzire',
  breadcrumbLabel: 'Maruti Dzire Commercial Taxi — Delhi',
  seoTitle: 'Maruti Suzuki Dzire Commercial Taxi for Sale — Delhi NCR',
  seoDescription: 'Buy used Maruti Suzuki Dzire CNG commercial taxis in Delhi NCR. India\'s most popular app-cab, verified BST listings with commercial RC.',
  keywords: 'Maruti Dzire commercial taxi Delhi, used Dzire CNG taxi Delhi, Dzire yellow plate Delhi, buy Dzire taxi Delhi NCR, Dzire taxi price Delhi 2026, Maruti Dzire CNG taxi operator, Ola Uber Dzire Delhi, Dzire resale value commercial',
  h1: 'Maruti Suzuki Dzire Commercial Taxi for Sale in Delhi NCR',
  answerCapsule: 'Used Maruti Suzuki Dzire commercial (CNG) taxis in Delhi NCR are priced between ₹2.5 lakh and ₹7 lakh depending on year and mileage. The Dzire is the most widely used sedan for Ola, Uber, and app-cab operations in Delhi due to its exceptional CNG mileage of 25–32 km/kg and low maintenance cost. Buy Sell Taxi lists verified Dzire units with commercial RC and CNG kit certification.',
  specs: [
    ['Category', 'Sedan / App-Cab Commercial Taxi'],
    ['Engine', '1.2L Petrol + CNG Kit'],
    ['Fuel Type', 'CNG (Primary) / Petrol'],
    ['Seating', '5 Seats'],
    ['Transmission', 'Manual (AMT available)'],
    ['CNG Mileage', '25–32 km/kg'],
    ['Boot Space', '378 litres'],
    ['Commercial Permit', 'City taxi permit / All India Tourist Permit'],
    ['Typical Use', 'Ola/Uber city cab, outstation sedan taxi, airport transfer'],
  ],
  priceData: [
    ['2017', '2,80,000 km', '₹2.5L – ₹3.5L', 'Average'],
    ['2018', '2,20,000 km', '₹3L – ₹4L',     'Good'],
    ['2019', '1,60,000 km', '₹3.8L – ₹5L',   'Very Good'],
    ['2020', '1,20,000 km', '₹4.5L – ₹6L',   'Excellent'],
    ['2021', '80,000 km',   '₹5.5L – ₹7.5L', 'Like New'],
  ],
  whyPoints: [
    'CNG mileage of 25–32 km/kg makes it the most economical sedan for high-frequency city cab operations.',
    'Factory CNG fitment (from 2018 onwards) is safer and more reliable than aftermarket kits.',
    'Wide service network — Maruti service centres are available across all Delhi NCR locations.',
    'Easy to get approved on Ola and Uber — meets all aggregator standards for the standard cab category.',
    'Low tyre and brake wear due to lighter kerb weight compared to larger sedans.',
  ],
  faqs: [
    {
      q: 'What is the CNG mileage of a Maruti Dzire used for commercial taxi operations in Delhi?',
      a: 'A Maruti Suzuki Dzire with factory-fitted CNG delivers 25–32 km/kg in real-world commercial taxi use in Delhi. City stop-and-go traffic reduces mileage to the lower end, while highway runs achieve 30+ km/kg. This translates to a per-km running cost of around ₹1.2–₹1.8 at current Delhi CNG prices.',
    },
    {
      q: 'What is the resale value of a commercial Maruti Dzire CNG taxi in Delhi in 2026?',
      a: 'A 2019 Maruti Suzuki Dzire with commercial RC and approximately 1.6 lakh km sells for ₹3.8–₹5 lakh in Delhi NCR in 2026. Vehicles with original factory CNG and valid CNG certification fetch a 10–15% premium over those with aftermarket CNG kits. BST Verified listings come with document checks.',
    },
    {
      q: 'How do I register a Maruti Dzire as a commercial taxi in Delhi?',
      a: 'To register a Maruti Dzire as a commercial taxi in Delhi, you need to apply for a transport vehicle fitness certificate at the Delhi RTO, change registration from private to commercial (yellow plate), and obtain a city taxi permit or All India Tourist Permit. Buying a Dzire that already has a commercial yellow plate RC avoids this process entirely.',
    },
    {
      q: 'Is a Dzire CNG taxi eligible to operate on Ola and Uber in Delhi?',
      a: 'Yes. A Maruti Suzuki Dzire with commercial yellow plate and a valid taxi permit qualifies for Ola Mini, Ola Prime, and Uber Go categories in Delhi. You\'ll need a valid CNG fitness certificate and commercial insurance. Most platforms accept Dzires up to 7 years old for standard categories.',
    },
    {
      q: 'What are the commercial financing options for buying a used Dzire taxi in Delhi?',
      a: 'Several banks and NBFCs offer commercial vehicle financing for used Dzire taxis in Delhi, including HDFC Bank, Axis Bank, and Mahindra Finance. Loan-to-value ratios for commercial vehicles are typically 70–85% of the assessed value. Interest rates range from 10–15% per annum for used commercial vehicles with a 1–4 year repayment tenure.',
    },
  ],
};

const DzireHub = () => <VehicleHub config={config} />;

export default DzireHub;
